import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = ({ onStartCourse }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-background">
        {/* Gradient orbs */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-[120px] animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/15 rounded-full blur-[120px] animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[150px]" />
        
        {/* Grid pattern */}
        <div 
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `
              linear-gradient(hsl(var(--primary) / 0.1) 1px, transparent 1px),
              linear-gradient(90deg, hsl(var(--primary) / 0.1) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-32 pb-20">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/80 border border-primary/30 backdrop-blur-sm mb-8">
            <span className="w-2 h-2 bg-primary rounded-full animate-pulse" />
            <span className="text-primary-foreground text-sm font-medium">
              Capacitación abierta para cuidadores de adopción
            </span>
          </div>

          {/* Main Heading */}
          <div className="mb-8 relative">
            {/* Glow effect behind text */}
<div className="absolute inset-0 flex items-center justify-center pointer-events-none">
  <div className="absolute w-[420px] h-[220px] bg-primary/25 rounded-full blur-[80px] animate-pulse" />
  <div className="absolute w-[360px] h-[180px] bg-accent/20 rounded-full blur-[60px] animate-pulse delay-1000" />
  <div className="absolute w-[500px] h-[260px] bg-primary/20 rounded-full blur-[100px] animate-pulse delay-500" />
</div>

            <h1 className="relative text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-none">
              <span className="block bg-gradient-to-r from-foreground via-accent to-foreground bg-clip-text text-transparent">
                ¿Cómo Acompañar
              </span>
              <span className="block mt-2 bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
                Con Más Calma?
              </span>
            </h1>
          </div>

          {/* CTA Button */}
          <div className="mb-12">
            <Button
              onClick={onStartCourse}
              className="group relative bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-lg font-semibold rounded-full transition-all duration-300 hover:scale-105 shadow-[0_0_40px_hsl(var(--primary)/0.4)]"
            >
              <span className="flex items-center gap-3">
                <Play className="w-5 h-5" />
                Comenzar el Curso
                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
              </span>
            </Button>
          </div>

          {/* Description */}
          <p className="text-muted-foreground text-lg md:text-xl max-w-3xl mx-auto leading-relaxed font-semibold">
            Un recorrido práctico de 6-módulos breves para sostener un
            vínculo de apego seguro durante tu relación cotidiana con el niño.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-primary/40 flex items-start justify-center p-1">
          <div className="w-1.5 h-3 bg-primary/60 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
